/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import ItemizeGroupTag from "../tag/ItemizeGroupTag";

interface GroupTagProps {
    conditionList?: { name: string; id: string; dotColor?: string }[]; // 表示ボタン一覧
    value?: string; // 現在選択中の値
    handleChange?: (name: string, id: string) => void;
    allIsDisplay?: boolean; // ALLを表示するかどうか
}

export const ALL_CONDITION = {
    name: "ALL",
    id: "ALL_ID",
    dotColor: "red",
};

const FilterTag = (props: GroupTagProps) => {
    const { conditionList, value, handleChange = () => {}, allIsDisplay = true } = props;

    const handleCheck = (event: { target: { value: string } }) => {
        const selectedItem = conditionList?.find((item) => item.id === event.target.value);
        if (!selectedItem) return;
        handleChange(selectedItem.name, selectedItem.id);
    };

    const _conditionList = conditionList?.filter((item) => item.id !== ALL_CONDITION.id);

    /**
     * 選択状態により色を変更する
     * @param id
     * @returns
     */
    const getBgcolor = (id: string) => (id === value ? "#29267A" : "#F5F6F6");
    const getFontColor = (id: string) => (id === value ? "white" : "#A0A0A0");

    return (
        <RadioGroup>
            <Grid container direction="row" sx={{ mt: 2, mb: 2, pl: 2 }}>
                {allIsDisplay && (
                    <FormControlLabel
                        control={<Radio sx={{ display: "none" }} onChange={handleCheck} value={String(ALL_CONDITION.id)} />}
                        label={
                            <ItemizeGroupTag
                                children={ALL_CONDITION.name}
                                style={{
                                    dotColor: ALL_CONDITION.dotColor,
                                    bgcolor: getBgcolor(ALL_CONDITION.id),
                                    fontColor: getFontColor(ALL_CONDITION.id),
                                }}
                                dotDisplay={"none"}
                            />
                        }
                    />
                )}

                {_conditionList?.map((item, index) => (
                    <FormControlLabel
                        key={index}
                        control={<Radio sx={{ display: "none" }} checked={item.id === value} onChange={handleCheck} value={String(item.id)} />}
                        label={
                            <ItemizeGroupTag
                                children={item.name}
                                style={{
                                    dotColor: item?.dotColor,
                                    bgcolor: getBgcolor(item.id),
                                    fontColor: getFontColor(item.id),
                                }}
                            />
                        }
                    />
                ))}
            </Grid>
        </RadioGroup>
    );
};

export default FilterTag;
